class Navigation {
  static globalNavigation = [
    {
      name: "Home",
      link: "/",
      type: "explore",
    },
    {
      name: "About Me",
      link: "/about-me",
      type: "explore",
    },
    {
      name: "Technology Stack",
      link: "/technology-stack",
      type: "explore",
    },
    {
      name: "Contact Me",
      link: "/contact-me",
      type: "explore",
    },
    {
      name: "Logo Design",
      link: "/service/logo-design",
      type: "services",
    },
    {
      name: "UI/UX Design",
      link: "/service/ui-ux-design",
      type: "services",
    },
    {
      name: "Web Development",
      link: "/service/web-development",
      type: "services",
    },
    {
      name: "Graphic Design",
      link: "/service/graphic-design",
      type: "services",
    },
    {
      name: "Motion Design",
      link: "/service/motion-design",
      type: "services",
    },
    {
      name: "3D Modelling",
      link: "/service/3d-modelling",
      type: "services",
    },
  ];

  static getNameByTitle = (title) => {
    const navigationItem = Navigation.globalNavigation.find(
      (item) => item.link.slice(9) === title
    );

    return navigationItem ? navigationItem.name : null;
  };

  static getLinkByTitle = (title) => {
    const navigationItem = Navigation.globalNavigation.find(
      (item) => item.name === title
    );

    return navigationItem ? navigationItem.link : null;
  };
}

export default Navigation;
